import VueI18n from "vue-i18n"
import { i18n } from "util/i18n"

export default function useTranslate(component: VueI18n.Path) {
  /**
   * @deprecated The method should not be used. It's too verbose. Use the "t$" method instead.
   */
  function t(key: VueI18n.Path, values?: VueI18n.Values): string {
    return i18n.t(`${component}.${key}`, values).toString()
  }

  /**
   * @deprecated The method should not be used. It's too verbose. Use the "tc$" method instead.
   */
  function tc(
    key: VueI18n.Path,
    choice?: number,
    values?: VueI18n.Values
  ): string {
    return i18n.tc(`${component}.${key}`, choice, values)
  }

  // with new syntax: leading "." in key indicates a relative path; else it's absolute
  function t$(key: VueI18n.Path, values?: VueI18n.Values): string {
    if (key.startsWith(".")) {
      return i18n.t(`${component}${key}`, values).toString()
    } else {
      return i18n.t(key, values).toString()
    }
  }

  // with new syntax: leading "." in key indicates a relative path; else it's absolute
  function tc$(
    key: VueI18n.Path,
    choice?: number,
    values?: VueI18n.Values
  ): string {
    if (key.startsWith(".")) {
      return i18n.tc(`${component}${key}`, choice, values)
    } else {
      return i18n.tc(key, choice, values)
    }
  }

  function getComponent(key: VueI18n.Path) {
    return useTranslate(`${component}.${key}`)
  }

  return { t, tc, t$, tc$, getComponent }
}
